export function addCurrent(contract) {
    return {
        type: 'ADD_CURRENT_CONTRACT',
        contract,
    }
}